<!-- 分页 -->
<template>
    <div class='pagination'>
        <el-pagination
            @current-change="handleCurrentChange"
            :page-size="page_size"
            layout="prev, pager, next"
            :hide-on-single-page="true"
            :total="pageTotal">
        </el-pagination>
    </div>
</template>

<script>
export default {
  props:['pageTotal','page_size'],
    data() {
    //这里存放数据
        return {
          // pageTotal:null,
          // page_size:12
        };
    },

    methods: {
      // 点击切换页码
      handleCurrentChange (val) { this.$emit('page',val) }
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    // created() {
    //   this.$Bus.$off('pageTotal').$on('pageTotal',val => this.pageTotal = val)
    //   this.$Bus.$off('pageSize').$on('pageSize',(val) => this.page_size = val)
    // }
}
</script>
<style lang='less'>
.pagination{
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100%;
  .el-pager li.active{
    background-color: #ffde00;
    color: #FFFFFF;
    border-color: #ffde00;
  }
  .el-pager li{
    margin: 0 5px;
    border-radius: 3px;
  }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #FFD600;
        color: #000000;
    }
    .el-pager li:hover{
      color: #3e3e3e;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover{
        color: #000000;
    }
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
        background-color: #ffff;
    }
    .el-pager li,.el-pagination button, .el-pagination span:not([class*=suffix]){
      width: 30px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #eaeaea;
      font-size: 14px;
      padding: 0;
      border-radius: 3px;
    }
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
        color: #9EA0A0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Pagination.vue